<template>
  <!-- Native mobile home on phones; desktop widget stack otherwise -->
  <mobile-home v-if="isPhone" />
  <v-container v-else fluid class="mt-16 px-6">
    <div class="pl-10 pr-10">
      <h1>Dashboard</h1>
      <div class="d-flex mt-5">
        <v-spacer></v-spacer>
        <company-performance-export
          v-if="can('accounting.performance_table')"
        />
      </div>

      <v-divider class=""></v-divider>
      <!-- VP Operations Overview -->
      <div v-if="can('dashboard.vp_operations')">
        <vp-operations-dashboard />
      </div>
      <!-- Procurement Summary Cards -->
      <div v-if="can('dashboard.procurement_summary')">
        <procurement-summary />
      </div>
      <!-- Inventory Alerts -->
      <div v-if="can('dashboard.low_stock_alert')">
        <low-stock-alert />
      </div>
      <!-- Printable Forms -->
      <div v-if="can('dashboard.printable_forms')">
        <printable-forms-card />
      </div>
      <!-- Field Orders -->
      <div v-if="can('dashboard.field_job_orders')">
        <field-job-orders />
      </div>
      <!-- Quotations Summary -->
      <div v-if="can('dashboard.quotations_summary')">
        <quotations-lookup />
      </div>
      <!-- Customer Retention (CRM) scorecard -->
      <div v-if="can('dashboard.customer_retention')">
        <customer-retention-dashboard />
      </div>
      <!-- Facility Equipment catalog -->
      <div v-if="can('dashboard.facility_equipment')">
        <facility-equipment-widget />
      </div>
      <!-- Equipment Inventory Checks (Form 9) -->
      <div v-if="can('dashboard.facility_equipment_checks')">
        <equipment-checks-widget />
      </div>
      <!-- Daily Facilities Checks (Form 8) -->
      <div v-if="can('dashboard.facility_daily_checks')">
        <daily-checks-widget />
      </div>
      <!-- Technician dashboard (hat-gated) -->
      <div v-if="can('dashboard.tech')">
        <tech-dashboard />
      </div>
      <!-- total cards only visible at access level 4 or admin-->
      <div v-if="can('dashboard.total_sales_summary')">
        <total-sales-summary />
      </div>
      <!-- unpaid invoices and pickuped units
          only visible at access level 3 or w/ staffs
        -->
      <div v-if="can('dashboard.picked_up_units')">
        <picked-up-units-summary />
      </div>
      <!-- Resellers table (hat-gated) -->
      <div v-if="can('dashboard.resellers')">
        <resellers-table />
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CompanyPerformanceExport from "../components/Dashboard/companyPerformanceExport.vue";
import TotalSalesSummary from "../components/Dashboard/totalSalesSummary.vue";
import PickedUpUnitsSummary from "../components/Dashboard/pickedUpUnitsSummary.vue";
import ResellersTable from "../components/Dashboard/resellersTable.vue";
import TechDashboard from "../components/Dashboard/techDashboard.vue";
import ProcurementSummary from "../components/Dashboard/procurementSummary.vue";
import LowStockAlert from "../components/Dashboard/lowStockAlert.vue";
import PrintableFormsCard from "../components/Dashboard/printableFormsCard.vue";
import FieldJobOrders from "../components/Dashboard/fieldJobOrders.vue";
import QuotationsLookup from "../components/Dashboard/quotationsLookup.vue";
import VpOperationsDashboard from "../components/Dashboard/vpOperationsDashboard.vue";
import CustomerRetentionDashboard from "../components/Dashboard/customerRetentionDashboard.vue";
import FacilityEquipmentWidget from "../components/Facilities/facilityEquipmentWidget.vue";
import EquipmentChecksWidget from "../components/Facilities/equipmentChecksWidget.vue";
import DailyChecksWidget from "../components/Facilities/dailyChecksWidget.vue";
import MobileHome from "../components/Dashboard/MobileHome.vue";
export default {
  async created() {
    await this.check_if_exist();
    this.ready = true;
  },
  data() {
    return {
      loading: false,
      ready: false,
    };
  },
  computed: {
    ...mapGetters({
      default_server_url: "auth/default_server_url",
      user: "auth/user",
      items: "item/items",
      summary: "summary/summary",

      unit_status: "unit/unit_status",
      chart_of_accounts: "chart_of_account/chart_of_accounts",
      hasPermission: "permission/hasPermission",
      user_permissions: "permission/user_permissions",
    }),
  },
  methods: {
    // Hat-based permission gate; accounts without hats get no access.
    can(key) {
      return this.hasPermission(key);
    },
    async refresh() {
      this.loading = true;

      await this.get_items();
      this.loading = false;
    },
    print_invoice(item, display_price) {
      let type = item.is_quote == 1 ? "quote" : "invoice";
      var url =
        this.default_server_url +
        "/print" +
        "/" +
        type +
        "/" +
        item.id +
        "/" +
        display_price;
      window.open(url);
    },
    async check_if_exist() {
      // only for staff/clerk/admin assistant
      if (this.can("dashboard.procurement_summary")) {
        if (!this.items) await this.get_items();

        if (this.chart_of_accounts.length <= 0)
          await this.get_chart_of_accounts();
        return;
      }
    },

    ...mapActions({
      get_items: "item/get_items",
      get_services: "service/get_services",
      get_summary: "summary/get_summary",
      get_yearly_summary: "summary/get_yearly_summary",
      get_chart_of_accounts: "chart_of_account/get_chart_of_accounts",
    }),
    signout() {
      this.$store.dispatch("auth/signout").then(() => {
        window.location = "/signin";
      });
    },
  },
  components: {
    CompanyPerformanceExport,
    TotalSalesSummary,
    PickedUpUnitsSummary,
    ResellersTable,
    TechDashboard,
    ProcurementSummary,
    LowStockAlert,
    PrintableFormsCard,
    FieldJobOrders,
    QuotationsLookup,
    VpOperationsDashboard,
    CustomerRetentionDashboard,
    FacilityEquipmentWidget,
    EquipmentChecksWidget,
    DailyChecksWidget,
    MobileHome,
  },
};
</script>

<style></style>
